import { createRouter, createWebHistory } from 'vue-router'

const SignInNav = () => import(/* webpackChunkName: "SignInNav" */ './components/SignInNav.vue')
const AccountSignin = () => import(/* webpackChunkName: "AccountSignin" */ './pages/AccountSignin.vue')
const EnterpriseSignin = () => import(/* webpackChunkName: "EnterpriseSignin" */ './pages/EnterpriseSignin.vue')

const routes = [
  {
    name: 'account-signin',
    path: '/account/signin',
    components: {
      sidebar: SignInNav,
      content: AccountSignin
    },
    meta: {
      title: 'LogDNA'
    }
  },
  {
    name: 'enterprise-signin',
    path: '/enterprise/signin',
    components: {
      sidebar: SignInNav,
      content: EnterpriseSignin
    },
    meta: {
      title: 'Access Management'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
